'use client';

import Link from 'next/link';
import { Dispatch, SetStateAction } from 'react';
import { User } from 'firebase/auth';

import { useHeaderAccount } from '@/src/components/header/HeaderAccount/useHeaderAccount';
import { Button } from '@/src/components/ui/button';

type IHeaderAccountProps = {
  signInTranslation: string | null;
  signOutTranslation: string | null;
  user: User | null;
  locale: string;
  setOpen?: Dispatch<SetStateAction<boolean>>;
};

export const HeaderAccount = ({
  signInTranslation,
  signOutTranslation,
  user,
  locale,
  setOpen,
}: IHeaderAccountProps) => {
  const { signOut } = useHeaderAccount();

  if (user) {
    return (
      <Button
        variant={'outlineTransparent'}
        size={'md'}
        className={'px-4 py-2.5 font-semibold lg:mx-auto xl:px-6 xl:py-4'}
        onClick={async () => {
          if (setOpen) setOpen(false);
          await signOut();
        }}
      >
        {signOutTranslation}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={'!size-auto'}
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" x2="9" y1="12" y2="12" />
        </svg>
      </Button>
    );
  }

  return (
    <Link
      className={'w-full no-underline lg:w-auto'}
      href={`/${locale}/auth/sign-in`}
      onClick={() => {
        window.dataLayer?.push({
          event: 'click_button',
          click_id: `/${locale}/auth/sign-in`,
          click_label: signInTranslation,
        });
        if (setOpen) setOpen(false);
      }}
    >
      <Button
        variant={'outlineTransparent'}
        size={'md'}
        className={
          'w-full px-4 py-2.5 font-semibold lg:mx-auto xl:px-6 xl:py-4'
        }
      >
        {signInTranslation}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={'!size-auto'}
        >
          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
          <polyline points="10 17 15 12 10 7" />
          <line x1="15" x2="3" y1="12" y2="12" />
        </svg>
      </Button>
    </Link>
  );
};
